import React from 'react';

/**
 * OnlineIndicator - Displays a green dot when user is online
 * @param {boolean} isOnline - Whether the user is online
 * @param {string} size - Size of the indicator: 'sm', 'md', 'lg'
 * @param {string} className - Additional CSS classes
 */
export const OnlineIndicator = ({ isOnline, size = 'md', className = '' }) => {
  if (!isOnline) return null;

  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3'
  };

  return (
    <span 
      className={`inline-block ${sizeClasses[size]} bg-green-500 rounded-full ring-2 ring-dark ${className}`}
      title="En ligne"
      data-testid="online-indicator"
    />
  );
};

/**
 * OnlineBadge - Displays username with online indicator
 * @param {string} pseudo - Username to display
 * @param {boolean} isOnline - Whether the user is online
 * @param {string} className - Additional CSS classes for the container
 */
export const OnlineBadge = ({ pseudo, isOnline, className = '' }) => {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      {pseudo}
      <OnlineIndicator isOnline={isOnline} size="sm" />
    </span>
  );
};

export default OnlineIndicator;
